module.exports = __webpack_public_path__ + "img/success-2.4fbea386.svg";